import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { EnvironmentProvider } from '@sbv-clients/data-access-api';
import { AuthProvider } from '@sbv-clients/shared-feature-auth';
import {
  AppQueryClientProvider,
  MuiXLicense,
  PreferenceProvider,
  ThemeProvider,
} from '@sbv-clients/ui-shared';

import { environment } from '../environments/environment';
import Routes from '../routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      retry: 1,
    },
  },
});

const ConfigurationInjector = ({ children }: { children: ReactNode }) => {
  return (
    <EnvironmentProvider
      apiBaseUrl={environment.apiBaseUrl}
      environment={environment.environment}
      reportsApiUrl=""
      client="admin"
      azureSSOConfig={{
        NX_APP_AZURE_AD_CLIENT_ID: environment.NX_APP_AZURE_AD_CLIENT_ID,
        NX_APP_AZURE_AD_AUTHORITY: environment.NX_APP_AZURE_AD_AUTHORITY,
        NX_APP_AZURE_AD_API_SCOPE: environment.NX_APP_AZURE_AD_API_SCOPE,
      }}
    >
      <PreferenceProvider>{children}</PreferenceProvider>
    </EnvironmentProvider>
  );
};

const App = () => {
  return (
    <ConfigurationInjector>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppQueryClientProvider>
            <ThemeProvider>
              <AuthProvider shouldRefreshTokenOnMount={false} type="admin">
                <Routes />
                <MuiXLicense />
              </AuthProvider>
            </ThemeProvider>
          </AppQueryClientProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigurationInjector>
  );
};

export default App;
